import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

const links = [
    { to: '/',         label: 'Home'     },
    { to: '/veil',     label: 'Veil of Veronica' },
    { to: '/devotion', label: 'Devotion' },
    { to: '/prayer',   label: 'Prayer'   },
    { to: '/chaplet',  label: 'Chaplet'  },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
            <NavLink to="/" className="nav__logo">Holy Face</NavLink>

            <ul className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
                {links.map(({ to, label }) => (
                    <li key={to}>
                        <NavLink
                            to={to}
                            end={to === '/'}
                            className={({ isActive }) =>
                                `nav__link ${isActive ? 'nav__link--active' : ''}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            {label}
                        </NavLink>
                    </li>
                ))}
            </ul>

            <button
                className={`nav__burger ${menuOpen ? 'nav__burger--open' : ''}`}
                onClick={() => setMenuOpen(v => !v)}
                aria-label="Toggle menu"
            >
                <span /><span /><span />
            </button>
        </nav>
    );
}
